import { Injectable } from '@angular/core';
import { HttpService } from '@app/core/http/http.service';
import { VolumeFilterView } from '@app/shared/models/ipm/VolumeFilterView';

import { Observable, Subject } from 'rxjs';

@Injectable()
export class ThresholdReportService {
  private sApiGenerateReport = '/api/reports/generateVolume';
  private sApiCheckMinDate   = '/api/reports/checkMinDate';

  private subjectUpdateLanguage = new Subject<any>();
  observableUpdateLanguage$ = this.subjectUpdateLanguage.asObservable();

  constructor(private httpService: HttpService,
  ) { }

  public createReport(volumeFilterView: VolumeFilterView) : any {
    return this.httpService.post<any>(this.sApiGenerateReport, volumeFilterView);
  }

  public checkMinDate(countryCode: string, airline: string) : Observable<Date> {
    return this.httpService.get<Date>(this.sApiCheckMinDate + '/country/' + countryCode + '/airline/' + airline);
  }

}
